import RoleFormConfig from "./form";
import GenericForm from "../GenericForm";
import { useEffect, useState } from "react";
import { RoleFormData } from "@/formTypes/RoleDataType";
import { RoleApi, RoleDataType } from "@/api/RoleApi";
import RoleRulesEditor from "./components/RuleEditor";
import { RoleRules } from "@/security/roles";

type RoleFormProps = {
  roleId?: string;
  formId: string,
  saveRedirectUrl: string
}

const RoleForm = (props: RoleFormProps) => {
  const { roleId } = props;
  const [role, setRoleField] = useState<RoleDataType>({});
  const [roleRules, setRoleRules] = useState<RoleRules>({})

  useEffect(() => {
    if (roleId) {
      const run = async () => {
        const data = await RoleApi.get(roleId);
        setRoleField(data);
        try {
          const existingRules = JSON.parse(data.rules)
          setRoleRules(existingRules)
        } catch (err) {
          setRoleRules({})
        }
      }
      run()
    }
  }, [roleId]);

  const setRules = (rules: RoleRules) => {
    setRoleRules(rules)
  }

  const saveRoleData = async (data: RoleDataType) => {
    const roleData = {
      ...data,
      rules: JSON.stringify(roleRules)
    }
    return await RoleApi.save(roleData)
  }

  return (
    <>
      <GenericForm<RoleFormData, RoleDataType>
        id={roleId}
        formId={props.formId}
        saveRedirectUrl={props.saveRedirectUrl}
        formConfig={RoleFormConfig}
        getById={(...arg) => RoleApi.get(...arg)}
        createFn={(data: RoleDataType) => saveRoleData(data)}
        updateFn={(id: string, data: RoleDataType) => saveRoleData(data)}
        successMessage="El Rol ha sido almacenada correctamente"
        errorMessage="No fue posible almacenar el Rol"
      />
      <hr />
      <RoleRulesEditor
        initialRules={roleRules}
        onChange={setRules}
      />
    </>
  )
}

export default RoleForm;